import { render, staticRenderFns } from "./BeneficiaryBillData.vue?vue&type=template&id=ad157b38&"
import script from "./BeneficiaryBillData.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryBillData.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryBillData.vue?vue&type=style&index=0&id=ad157b38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports